import { FC, memo } from "react";
import ReactMarkdown, { Options } from "react-markdown";

interface MemoizedOptions extends Options {
  cacheKey?: string;
}

export const MemoizedReactMarkdown: FC<MemoizedOptions> = memo(
  ({ cacheKey: _, ...props }) => <ReactMarkdown {...props} />,
  (prevProps, nextProps) => (
    prevProps.children === nextProps.children &&
    prevProps.className === nextProps.className &&
    prevProps.cacheKey === nextProps.cacheKey
  )
);